import React from 'react';
import { Button } from '../button';
import { Icon } from '../icon';
import { RangeWrapper, RangeCounter, RangePrevButton, RangeNextButton } from './styled';
const PrevIcon = React.createElement(Icon, { name: "arrow_back" });
const NextIcon = React.createElement(Icon, { name: "arrow_forward" });
const Range = ({ currentPage, totalPages, onNextPageChange, onPrevPageChange, ...rest }) => {
    return (React.createElement(RangeWrapper, { ...rest },
        React.createElement(RangePrevButton, null,
            React.createElement(Button, { variant: "outline", "aria-label": "previous page", disabled: currentPage === 1, onClick: onPrevPageChange, StartIcon: PrevIcon })),
        React.createElement(RangeCounter, null,
            "Page ",
            currentPage,
            " of ",
            totalPages),
        React.createElement(RangeNextButton, null,
            React.createElement(Button, { variant: "outline", "aria-label": "next page", disabled: currentPage === totalPages, onClick: onNextPageChange, StartIcon: NextIcon }))));
};
export default Range;
